import request from './request';
import deserialize from './deserialize';

type Image = {
  id: string;
  versions: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
};

export type RewardTemplate = {
  id: string;
  createdAt: number;
  gift: boolean;
  info: string;
  sell: boolean;
  title: string;
  updatedAt: number;
  what: string;
  images?: Image;
};

export function list(companyId: string) {
  return request<RewardTemplate[]>({
    url: `/v1/companies/${companyId}/reward_templates`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
